import type { JSX, PropsWithChildren } from 'react'

type Props = PropsWithChildren<{
  topBar?: JSX.Element
}>

export function PageLayout({ topBar, children }: Props) {
  return (
    <div className="grid h-dvh grid-rows-[auto_1fr]">
      {topBar}
      <div className="flex grow flex-col min-w-0 min-h-0">{children}</div>
    </div>
  )
}
